@if (cfg.appName === "ia") {
  <!-- asset/plant header -->
  <div class="header-wrapper multiple-btns">
    @if (!backBtn()) {
      <ng-container>
        <a aria-label="Home" [routerLink]="['/home']"
          ><img
            id="loctite-logo"
            alt="loctite-logo"
            src="assets/images/LoctitePulseLogo.svg"
        /></a>
      </ng-container>
    }
    @if (backBtn()) {
      <ng-container>
        <a
          class="back-btn"
          (click)="back()"
          (keypress)="back()"
          role="button"
          tabindex="0"
          aria-label="label"
        >
          <i nz-icon nzType="icons:arrow-left" class="svg-icon"></i>
          <span class="body-bold">{{ i18n.langString("settings") }}</span>
        </a>
      </ng-container>
    }

    <div class="header-content">
      <span class="body-bold">{{ title() }}</span>
    </div>
    <app-tab-menu [header]="true"></app-tab-menu>
  </div>
}

@if (cfg.appName === "em") {
  <!-- asset/plant header -->
  <div class="header-wrapper">
    @if (!backBtn()) {
      <a aria-label="Home" [routerLink]="['/home']">
        <img id="loctite-logo" src="assets/images/LoctitePulseLogo.svg" />
      </a>
    } @else {
      <a class="back-btn" (click)="back()" aria-label="label">
        <i nz-icon nzType="icons:arrow-left" class="svg-icon"></i>
        <span class="body-bold">{{ backToValue() }}</span>
      </a>
    }

    <div class="header-content">
      <span class="body-bold">{{ title() }}</span>
    </div>

    <app-tab-menu [header]="true"></app-tab-menu>

    <!-- banner Notification -->
    <app-banner-notification></app-banner-notification>
  </div>
}
